import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
  
} from "@react-pdf/renderer";

import imgKkp from "../../assets/img/logo-kkp.png";
import srcArial from "../../assets/font/arial/arial.ttf";
import srcArialBold from "../../assets/font/arial/ARIBL0.ttf";

// REGISTER FONT (GLOBAL, SEKALI)
Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });
// Font.registerHyphenationCallback(word => [word]);


export const s = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingLeft:20,
    paddingRight:20,
    fontSize: 10,
    fontFamily: "Arial",
  },

  title: {
    textAlign: "center",
    fontFamily: "Arial-Bold",
    marginVertical: 6,
  },

  subtitle: {
    textAlign: "center",
    fontSize: 9,
    marginBottom: 10,
  },

  row: {
    flexDirection: "row",
    marginBottom: 4,
  },

  noCol: {
    width: 18,
  },

  label: {
    width: 140,
  },

  colon: {
    width: 6,
  },

  value: {
    flex: 1,
  },

  fieldRow: {
    flexDirection: "row",
    marginBottom: 2,
  },

  bold: {
    fontFamily: "Arial-Bold",
  },

  ttd: {
    marginTop: 30,
    alignItems: "center",
  },
  table: {
  display: "table",
  width: "100%",
  borderWidth: 1,
  borderStyle: "solid",
},

tableRow: {
  flexDirection: "row",
},

tableColNo: {
  width: "3.5%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColLabel: {
  width: "47%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColValue: {
  width: "50%",
  borderBottomWidth: 1,
  padding: 4,
},
tableColLabel2: {
  width: "60%",
  padding: 4,
},
tableColValue2: {
  width: "40%",
   padding: 4,
},

text: {
  fontSize: 10,
  lineHeight: 1.3,
},

});
const tableRows = [
  { 
    no: "II", 
    tibaDi: "Tangerang", tglTiba: "1 Januari 2025", 
    berangkatDari: "BBKIPM Jakarta I", ke: "Tangerang", tglBerangkat: "1 Januari 2026" 
  },
  { no: "III", tibaDi: "", tglTiba: "", berangkatDari: "", ke: "", tglBerangkat: "" },
  { no: "IV", tibaDi: "", tglTiba: "", berangkatDari: "", ke: "", tglBerangkat: "" },
  { no: "V", tibaDi: "", tglTiba: "", berangkatDari: "", ke: "", tglBerangkat: "" },
];

const data = {
  // PEJABAT PEMBERI PERINTAH
  ppk: "Pejabat Pembuat Komitmen Balai Besar KIPM Jakarta I",

  // PEGAWAI YANG DINAS
  nama: "Galih Pratomo Suwatno",
  nip: "198805242010121002",

  // PANGKAT & JABATAN
  pangkat: "Penata Muda Tk. I, III/b",
  jabatan: "Inspektur Mutu Hasil Perikanan Ahli Mahir / BBKIPM Jakarta I",
  tingkat: "C",

  // MAKSUD PERJALANAN
  maksud:
    "Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan",

  // TRANSPORTASI
  transportasi: "Kendaraan Umum",

  // LOKASI
  berangkat: "Balai Besar KIPM Jakarta I, Tangerang",
  tujuan:
    "PT. Bumi Pertiwi Mulia, Jl. Pergudangan Bandara Mas Blok M No.21, Kota Tangerang",

  // WAKTU
  lama: "1 (Satu) hari",
  tglBerangkat: "8 November 2025",
  tglKembali: "8 November 2025",

  // PENERBIT
  tempat: "Tangerang",
  tanggal: "8 November 2025",

  // PPK TTD
  ppkNama: "Muklasin",
  ppkNip: "198110112008011012",
};


export default function SPPDDepan() {
  return (
    <Document>
    <Page size="A4" style={s.page}>
        <View style={[s.tableRow,{paddingBottom:4}]}>
            <View style={s.tableColLabel2}>
           
            </View>
                <View style={s.tableColValue2}>
                <Text style={{ fontSize: 9 }}>
                Lampiran VI (2 dari 4){"\n"}
                Keputusan Menteri Keuangan {"\n"}
                Perjalanan Dinas Dalam Negeri Bagi Pejabat {"\n"}
                negara, Pegawai Negeri Sipil dan Pegawai {"\n"}
                Tidak Tetap {"\n"}
                Nomor : 113/PMK.05/2012 {"\n"}
                Tanggal : 3 Juli 2012 
                </Text>
            </View>
        </View>

        <View style={s.table}>
               
         <View style={s.tableRow}>
              <View style={{ width :"100%", 
                                      }}>
                <View style={s.tableRow}>
                    <View style={{ width: "18%"}}>
                        <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                            </Text>
                    </View>
                    <View style={{ width : "30.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                             
                        </Text>
                    </View>
                    
                    <View style={{ width: "45%"}}>
                        <View style={s.tableRow}>
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                                    I
                                </Text>
                            </View>
                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                                    Berangkat dari   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:4}]}>
                                    : BBKIPM Jakarta I
                                </Text>
                            </View>
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    (Tempat Kedudukan)   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : Tangerang
                                </Text>
                            </View>                    
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Ke   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : Tangerang
                                </Text>
                            </View>                    
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Pada Tanggal  </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : 1 Januari 2026
                                </Text>
                            </View>                    
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Plt.
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Kepala   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    
                                </Text>
                            </View>                    
                        </View>
                        
                        <View style={[s.tableRow, {paddingTop:40}]}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "95%"}}>
                                <Text style={[s.bold,{paddingBottom:2,paddingLeft:4}]}>
                                    (Agung Santoso)  {"\n"}
                                    NIP 19770815 200312 1 003   </Text>
                            </View>              
                        </View>
                    </View> 
                </View>
                

                {/* <View style={[s.tableRow,{borderTopWidth: 1}]}>
                    <View style={{ width: "48.5%", borderRightWidth: 1}}>
                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    II
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Tiba di   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : Tangerang
                                </Text>
                            </View>                    
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "10%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    
                                </Text>
                            </View>

                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Pada Tanggal   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : 1 Januari 2025
                                </Text>
                            </View>                    
                        </View>
                    </View>
                    
                    
                    <View style={{ width: "45%"}}>
                        <View style={s.tableRow}>
                           <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>
                                    Berangkat dari   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:4}]}>
                                    : BBKIPM Jakarta I
                                </Text>
                            </View>
                        </View>

                        <View style={s.tableRow}>               
                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Ke   </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : Tangerang
                                </Text>
                            </View>                    
                        </View>

                        <View style={[s.tableRow,{paddingBottom:50}]}>               
                            <View style={{ width: "45%"}}>
                                <Text style={[s.text,{paddingTop:2,paddingLeft:4}]}>
                                    Pada Tanggal  </Text>
                            </View>
                            <View style={{ width : "45%" }}>
                                <Text style={[s.text,{paddingTop:2}]}>
                                    : 1 Januari 2026
                                </Text>
                            </View>                    
                        </View>
                    </View> 
                </View> */}
                     
                {tableRows.map((row, index) => (
                    <View key={index} style={[s.tableRow, { borderTopWidth: 1 }]}>
                        
                        {/* BAGIAN KIRI: TIBA (Width: 48.5%) */}
                        <View style={{ width: "48.5%", borderRightWidth: 1 }}>
                        <View style={s.tableRow}>
                            <View style={{ width: "10%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>{row.no}</Text>
                            </View>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Tiba di</Text>
                            </View>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2 }]}>: {row.tibaDi}</Text>
                            </View>
                        </View>

                        <View style={s.tableRow}>
                            <View style={{ width: "10%" }}><Text /></View>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Pada Tanggal</Text>
                            </View>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2 }]}>: {row.tglTiba}</Text>
                            </View>
                        </View>
                        </View>

                        {/* BAGIAN KANAN: BERANGKAT (Width: 51.5% atau sisanya) */}
                        <View style={{ width: "51.5%" }}>
                        <View style={s.tableRow}>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Berangkat dari</Text>
                            </View>
                            <View style={{ width: "55%" }}>
                            <Text style={[s.text, { paddingTop: 2 }]}>: {row.berangkatDari}</Text>
                            </View>
                        </View>

                        <View style={s.tableRow}>
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Ke</Text>
                            </View>
                            <View style={{ width: "55%" }}>
                            <Text style={[s.text, { paddingTop: 2 }]}>: {row.ke}</Text>
                            </View>
                        </View>

                        <View style={[s.tableRow, { paddingBottom: 50 }]}> 
                            <View style={{ width: "45%" }}>
                            <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Pada Tanggal</Text>
                            </View>
                            <View style={{ width: "55%" }}>
                            <Text style={[s.text, { paddingTop: 2 }]}>: {row.tglBerangkat}</Text>
                            </View>
                        </View>
                        </View>

                    </View>
                    ))}

                    <View style={[s.tableRow, { borderTopWidth: 1 }]}>
                        
                        {/* BAGIAN KIRI: TIBA (Width: 48.5%) */}
                        <View style={{ width: "48.5%", borderRightWidth: 1 }}>
                            <View style={s.tableRow}>
                                <View style={{ width: "10%" }}>
                                <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>VI</Text>
                                </View>
                                <View style={{ width: "45%" }}>
                                <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Tiba di</Text>
                                </View>
                                <View style={{ width: "45%" }}>
                                <Text style={[s.text, { paddingTop: 2 }]}>: </Text>
                                </View>
                            </View>

                            <View style={s.tableRow}>
                                <View style={{ width: "10%" }}><Text /></View>
                                <View style={{ width: "45%" }}>
                                <Text style={[s.text, { paddingTop: 2, paddingLeft: 4 }]}>Pada Tanggal</Text>
                                </View>
                                <View style={{ width: "45%" }}>
                                <Text style={[s.text, { paddingTop: 2 }]}>: </Text>
                                </View>
                            </View>
                        </View>

                        {/* BAGIAN KANAN: BERANGKAT (Width: 51.5% atau sisanya) */}
                        <View style={{ width: "51.5%" }}>
                            <View style={s.tableRow}>
                                <View style={{ width: "98%" }}>
                                <Text style={[s.text, { paddingTop: 4, paddingLeft: 4 }]}>
                                    Telah diperiksa dengan keterangan bahwa
                                    Perjalanan tersebut atas perintahnya dan semata-mata
                                    untuk kepentingan jabatan dalam waktu yang sesingkatsingkatnya.

                                    </Text>
                                </View>
                                
                            </View>
                        </View>

                    </View>
                    <View style={[s.tableRow]}>
                        
                        {/* BAGIAN KIRI: TIBA (Width: 48.5%) */}
                        <View style={{ width: "48.5%", borderRightWidth: 1 }}>
                           <View style={s.tableRow}>
                                <View style={{ width: "10%" }}><Text /></View>
                                <View style={{ width: "90%" }}>
                                <Text style={[s.text, { paddingTop: 5, paddingLeft: 4 }]}>
                                    Pejabat Pembuat Komitmen
                                </Text>
                                </View>
                            </View>
                            <View style={s.tableRow}>
                                <View style={{ width: "10%" }}><Text /></View>
                                <View style={{ width: "90%" }}>
                                <Text style={[s.bold, { paddingTop: 40, paddingLeft: 4 }]}>
                                    Nama PPK {"\n"}
                                    NIP PPK
                                </Text>
                                </View>
                            </View>
                        </View>

                        {/* BAGIAN KANAN: BERANGKAT (Width: 51.5% atau sisanya) */}
                        <View style={{ width: "51.5%" }}>
                            <View style={s.tableRow}>
                                
                                <View style={{ width: "90%" }}>
                                <Text style={[s.text, { paddingTop: 5, paddingLeft: 4 }]}>
                                    Pejabat Pembuat Komitmen
                                </Text>
                                </View>
                            </View>
                            <View style={s.tableRow}>
                                
                                <View style={{ width: "90%" }}>
                                <Text style={[s.bold, { paddingTop: 40, paddingLeft: 4 }]}>
                                    Nama PPK {"\n"}
                                    NIP PPK
                                </Text>
                                </View>
                            </View>                      
                        </View>
                    </View>

                    <View style={[s.tableRow, { borderTopWidth: 1 }]}>
                        
                        {/* BAGIAN KIRI: TIBA (Width: 48.5%) */}
                        <View style={{ width: "48.5%", borderRightWidth: 1 }}>
                           <View style={s.tableRow}>
                                <View style={{ width: "10%" }}><Text />VII.</View>
                                <View style={{ width: "90%" }}>
                                <Text style={[s.text, { paddingLeft: 4 }]}>
                                    Catatan Lain-lain : 
                                </Text>
                                </View>
                            </View>
                            
                        </View>

                        {/* BAGIAN KANAN: BERANGKAT (Width: 51.5% atau sisanya) */}
                        <View style={{ width: "51.5%" }}>
                            <View style={s.tableRow}>
                                
                                <View style={{ width: "90%" }}>
                                
                                </View>
                            </View>
                            <View style={s.tableRow}>
                                
                                <View style={{ width: "90%" }}>
                                
                                </View>
                            </View>                      
                        </View>
                    </View>

            </View>
         </View>
       </View>

       <View style={[s.tableRow,{paddingBottom:4}]}>
        <View style={{ width: "100%" }}>
        <Text style={[s.text, {  paddingLeft: 4 }]}>
            VIII. PERHATIAN
        </Text>
        <Text style={[ { fontSize: 9, textAlign: "justify", PaddingLeft: 20, paddingRight: 10 }]}>
           {"     "} Pejabat yang berwenang menerbitkan SPPD, pegawai yang melakukan perjalanan dinas, para
            pejabat yang mengesahkan tanggal berangkat/ tiba, serta bendaharawan bertanggung jawab
            berdasarkan peraturan-peraturan Keuangan Negara apabila Negara menderita rugi akibat kesalahan,
            kelalaian dan kesipaannnya. 
        </Text>
        </View>
        </View>
     
    </Page>
  </Document>
  );
}
